<h1 mat-dialog-title>Notificare Push</h1>
<div mat-dialog-content fxLayout="column" fxLayoutGap="10px" >
    <div class="form-group" fxFlex="auto">
        <label class="label" for="title">Titlu</label>
        <input nbInput [(ngModel)]="data.title" placeholder="Titlu" id="title" name="title">
    </div>
    <div class="form-group" fxFlex="auto">
        <label class="label" for="body">Mesaj</label>
        <input nbInput [(ngModel)]="data.body" placeholder="Mesaj" id="body" name="body">
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Anulează</button>
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Trimite</button>
</div>
